<!-- 消息列表 -->
<template>
    <div class="business-content-main message-main">
        <div class="message-content">
            <div class="message-title">我的消息</div>
            <div class="tabs-btn-ctn">
                <div class="tab-btn-item" @click="tabToggle(0)" :class="{ 'tab-active': tabInd == 0 }">全部</div>
                <!--<div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">维修预约</div>-->
                <!--<div class="tab-btn-item" @click="tabToggle(2)" :class="{'tab-active':tabInd == 2}">采购订单</div>-->
                <!--<div class="tab-btn-item" @click="tabToggle(3)" :class="{'tab-active':tabInd == 3}">其他</div>-->
                <el-button size="small" class="mark-btn btn-primary" @click="markAll">全部标记为已读</el-button>
            </div>
            <div class="base-content">
                <div v-show="tabInd == 0">
                    <div v-if="tableDataLength != 0">
                        <div class="message-list">
                            <div class="message-item" v-for="(item, index) in tableData" :key="item.NId">
                                <p :class="{ 'is-link': item.RedirectUrl }" @click="markRead(item.IsRead, item.NId, item.RedirectUrl, index)">
                                    <span class="no-read" v-if="!item.IsRead"></span>
                                    <span class="message-item-title">{{ item.Title }}</span>
                                </p>
                                <div class="Content" :class="{ 'content-close': !item.open }">{{ item.Content }}</div>
                                <div class="message-item-footer">
                                    <div>{{ item.PublishTime }}</div>
                                    <div class="read-more" v-if="item.Content.length > 170">
                                        <span v-if="!item.open" @click="contentOpen(index, 1)">展开</span>
                                        <span v-else @click="contentOpen(index, 0)">收起</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pagination-ctn">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="searchData.page"
                                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                                :page-size="searchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableDataLength"
                            >
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else>暂无消息</div>
                </div>
                <div v-show="tabInd == 1"></div>
                <div v-show="tabInd == 2"></div>
                <div v-show="tabInd == 3"></div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {},
    data() {
        return {
            tabInd: 0,
            tableData: [],
            tableDataLength: 0,
            searchData: {
                uid: this.$util.getLocalStorage('userMsg').EmployeeId,
                page: 1,
                limit: 15,
                key: ''
            }
        };
    },
    mounted() {
        this.getMessage();
    },
    methods: {
        contentOpen(index, type) {
            let _data = this.tableData;
            if (type == 0) {
                _data[index].open = false;
            } else {
                _data[index].open = true;
            }
        },
        // 全部标记已读
        markAll() {
            let arr = [];
            let str = '';
            for (let i = 0; i < this.tableData.length; i++) {
                if (!this.tableData[i].IsRead) {
                    arr.push(this.tableData[i].NId);
                }
            }
            str = arr.join(',');
            if (str) {
                this.$util
                    .axiosPost({
                        url: '/api/Notification/MarkNotificationAsRead',
                        data: {
                            NIds: str,
                            UId: this.searchData.uid
                        }
                    })
                    .then(() => {
                        let timestamp = new Date().getTime();
                        this.$store.commit('updateMessageNum', timestamp);
                        // this.$util.successMsg('全部标记已读成功')
                        this.getMessage();
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('没有未读消息');
            }
        },
        // 标记已读
        markRead(IsRead, NId, RedirectUrl, index) {
            if (IsRead && RedirectUrl) {
                this.$router.push(RedirectUrl);
            } else {
                if (IsRead) {
                    return;
                } else {
                    this.tableData[index].IsRead = true;
                    this.$util
                        .axiosPost({
                            url: '/api/Notification/MarkNotificationAsRead',
                            data: {
                                NIds: NId,
                                UId: this.searchData.uid
                            }
                        })
                        .then(() => {
                            let timestamp = new Date().getTime();
                            this.$store.commit('updateMessageNum', timestamp);
                            if (RedirectUrl) {
                                this.$router.push(RedirectUrl);
                            }
                        })
                        .catch(() => {});
                }
            }
        },
        // 跳转消息详情
        gotoDetails(item) {
            this.$util.gotoMessageDetails(this, item);
        },
        // 获取通知列表
        getMessage() {
            this.$util
                .axiosGet({
                    url: '/api/Notification/GetNotificationList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    for (let i = 0; i < data.length; i++) {
                        data[i].open = false;
                    }
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 切换最上面的tab
        tabToggle(i) {
            this.tabInd = i;
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getMessage();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getMessage();
        }
    }
};
</script>
<style lang="less" scoped>
.read-more {
    color: @theme;
    cursor: pointer;
}
.message-item-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.message-item-title {
    font-weight: bold;
}
.message-content {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
}
.Content {
    overflow-wrap: break-word;
    line-height: 1.5em;
    margin-bottom: 20px;
}
.message-title {
    font-size: 24px;
    margin-bottom: 20px;
}
.mark-btn {
    position: absolute;
    right: 0;
    bottom: 0;
}
.message-main {
    margin: 0 auto;
    height: 100%;
    overflow: auto;
}
.message-item {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid @border3Color;
    p {
        cursor: pointer;
        color: @font1Color;
        margin-bottom: 20px;
    }
}
.is-link {
    &:hover {
        color: @theme;
    }
}
.no-read {
    display: inline-block;
    background: @theme;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
}
.tabs-btn-ctn {
    max-width: 1200px;
    position: relative;
    border-bottom: 1px solid @border1Color;
    .tab-btn-item {
        flex-grow: 0;
        width: 120px;
        padding: 0 10px;
        border-bottom: none;
    }
}
.base-content {
    padding-top: 20px;
    max-width: 1200px;
}
.content-close {
    max-height: 3em;
    overflow: hidden;
}
</style>
